export function trigger() {
  const triggerNav = document.querySelector('.trigger-nav');
  if(triggerNav) {
    triggerNav.addEventListener('click', function(e) {
      document.body.classList.remove('is-drawer-active', 'is-search-active');
      if(searchInput) {
        searchInput.blur();
      }
      if(!document.body.classList.contains('is-nav-active')){
        document.body.classList.add('is-nav-active', 'is-disable-scroll-direction');
      } else {
        document.body.classList.remove('is-nav-active');
        setTimeout(() => {
          document.body.classList.remove('is-disable-scroll-direction');
        }, 100)
      }
      e.preventDefault();
    });
  }
  
  const searchInput = document.querySelector('.search-input');
  const triggerSearch = document.querySelector('.trigger-search');
  if(triggerSearch) {
    triggerSearch.addEventListener('click', function(e) {
      document.body.classList.remove('is-drawer-active', 'is-nav-active');
      if(!document.body.classList.contains('is-search-active')){
        document.body.classList.add('is-search-active', 'is-disable-scroll-direction');
        if(searchInput) {
          searchInput.focus();
        }
      } else {
        document.body.classList.remove('is-search-active');
        setTimeout(() => {
          document.body.classList.remove('is-disable-scroll-direction');
        }, 100)
      }
      e.preventDefault();
    });
  }

  const close = document.querySelectorAll('.trigger-close');
  if(close.length) {
    close.forEach((el, index) => {
      el.addEventListener('click', function(e) {
        document.body.classList.remove('is-nav-active','is-search-active','is-drawer-active');
        if(searchInput) {
          searchInput.blur();
        }
        setTimeout(() => {
          document.body.classList.remove('is-disable-scroll-direction');
        }, 100)
        e.preventDefault();
      });
    });
  }

  let lastInnerWidth = window.innerWidth;
  window.addEventListener("resize", () => {
    if (lastInnerWidth != window.innerWidth) {
      document.body.classList.remove('is-nav-active', 'is-search-active');
      if(searchInput) {
        searchInput.blur();
      }
      setTimeout(() => {
        document.body.classList.remove('is-disable-scroll-direction');
      }, 100)
      lastInnerWidth = window.innerWidth;
    }
  });
}